import { useEffect } from "react";
import { useLocation } from "wouter";
import { useAuth } from "@/lib/auth-store";

/**
 * Envuelve rutas privadas. Si no hay sesión → /login.
 * El landing público y /login no usan este gate.
 */
export function AuthGate({ children }: { children: React.ReactNode }) {
  const user = useAuth((s) => s.user);
  const token = useAuth((s) => s.accessToken);
  const [location, setLocation] = useLocation();

  useEffect(() => {
    if (!token || !user) {
      setLocation("/login");
    }
  }, [token, user, location, setLocation]);

  if (!token || !user) return null;
  return <>{children}</>;
}
